import axios from 'axios';

import Vue from 'vue';

let vue = Vue.prototype;

import qs from 'qs';

import store from '../store';

import router from '../router/index';

import i18n from '@/i18n/index.js';

import Cookies from 'js-cookie'; // cookie插件

axios.defaults.timeout = 60 * 1000; // 响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'; // 配置请求头

/**
 * 环境的切换 - 配置接口地址
 */
axios.defaults.baseURL = '/console-api'; // 线上地址
// if (process.env.NODE_ENV === 'development') {
//     axios.defaults.baseURL = '/api'; // 开发地址
// } else if (process.env.NODE_ENV === 'production') {
//     axios.defaults.baseURL = window.jmConfig.baseURL; // 线上地址
// }
const langMap = {
  zh: ['zh-CN', 'zh_CN'],
  en: ['en-US', 'en_US']
};

/**
 * 请求拦截器
 */
axios.interceptors.request.use(
  (config) => {
    if (store.state.login.token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = 'Bearer ' + store.state.login.token;
    }
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8') {
      config.data = qs.stringify(config.data, {
        arrayFormat: 'repeat'
      }); // 序列化请求参数;
    }

    // header用中划线
    const lang = langMap[Cookies.get('locale')];
    config.headers['Accept-Language'] = lang[0];

    // url用下划线
    const langParams = `lang=${lang[1]}`;
    if (!config.params || !config.params.lang) {
      if (config.url.includes('?')) {
        config.url = config.url + `&${langParams}`;
      } else {
        config.url = config.url + `?${langParams}`;
      }
    }

    return config;
  },
  (err) => {
    vue.$uxLoading?.hide();
    return Promise.reject(err);
  }
);

/**
 * 响应拦截器
 */
axios.interceptors.response.use(
  (res) => {
    vue.$uxLoading?.hide();

    if (res.data.code !== 10000 && !res.config.config) {
      vue.$uxMessage?.error(`${res.data.sub_msg || res.data.msg}`);
    }
    if (res.data.code === 20001) {
      vue.$uxModal?.hide();
      router.replace({ path: '/login' });
    }
    return res;
  },
  (err) => {
    vue.$uxLoading?.hide();
    if (err.response?.data.code === 20001 || err.response?.data.sub_code === 'token.invalid') {
      vue.$uxModal?.hide();
      router.replace({ path: '/login' });
    }
    if (err.response) {
      const response = err.response;
      // 不显示错误信息
      if (response.config.hideMsg) {
        // 没有错误信息
        if (!response.data.sub_msg) {
          vue.$uxMessage?.error(i18n.t('HT.http.error'));
        }
      } else {
        console.log('12312312321321312');
        vue.$uxMessage?.error(i18n.t(response.data.sub_msg) || i18n.t('HT.http.error'));
      }
    } else {
      vue.$uxMessage?.error(i18n.t('HT.http.error'));
    }

    return Promise.reject(err);
  }
);

export default axios;

/**
 * get方法
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 请求的配置
 */
export function get(url, params, config) {
  let time = new Date().getTime();
  return new Promise((resolve, reject) => {
    const httpConfig = {
      params: params,
      config: config
    };
    if (config?.responseType) {
      httpConfig.responseType = config.responseType;
    }
    axios
      .get(`${url}?time=${time}`, httpConfig)
      .then((res) => {
        if (config?.responseType === 'blob') {
          resolve(res, res);
        } else {
          resolve(res.data, res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post方法
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 请求的配置
 */
export function post(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then((res) => {
        resolve(res.data, res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * put方法
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 请求的配置
 */
export function put(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params, config)
      .then((res) => {
        resolve(res.data, res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * patch方法
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 请求的配置
 */
export function patch(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, params, config)
      .then((res) => {
        resolve(res.data, res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * delete方法
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 请求的配置
 */
export function del(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
        config: config
      })
      .then((res) => {
        resolve(res.data, res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// 后端接口不标准，delete参数要放到body中，这里单独处理
export function remove(url, params, config) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        data: params,
        config: config
      })
      .then((res) => {
        resolve(res.data, res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}